<template>
  <div class="d-flex flex-row export-options">
    <v-skeleton-loader
      v-if="!exportOptionsArray.length"
      class="mx-auto border"
      max-width="300"
      type="actions"
    />
    <div
      v-else
      v-for="{ data: { sourceDetails } } in exportOptionsArray"
      :key="sourceDetails.SOURCE_ID"
    >
      <v-tooltip bottom max-width="300px" v-if="!sourceDetails.HAS_CONSENT">
        <template v-slot:activator="{ on, attrs }">
          <div class="w-100" v-on="on" v-bind="attrs">
            <export-options-list-item
              :sourceDetails="sourceDetails"
              :selectedOption="selectedOption"
              @updateSelectedOption="updateSelectedOption"
              />
            </div>
          </template>
          <span class="tooltip text-center font10 mb-1">
            {{ tooltipText(sourceDetails.SOURCE_ID) }}
          </span>
        </v-tooltip>
        <export-options-list-item
        v-else
        :sourceDetails="sourceDetails"
        :selectedOption="selectedOption"
        @updateSelectedOption="updateSelectedOption"
      />
    </div>
  </div>
</template>

<script>
const ExportOptionsListItem = () =>
  import('@/components/ArchiveSearch/ExportOptionsModal/ExportOptionsListItem');
import { mapGetters } from 'vuex';
export default {
  components: { ExportOptionsListItem },
  props: {
    exportOptionsArray: {
      required: true,
      type: Array
    },
    selectedOption: {
      required: true,
      type: String
    }
  },
  computed: {
    tooltipText() {
      return sourceId => {
        const exportConnectorId = this.$enums.connectorsWritePermissionMap[
          sourceId
        ];

        let exportConnectorName = '';

        this.connectorList().map(
          ({
            data: {
              sourceDetails: { SOURCE_ID, SOURCE_NAME }
            }
          }) => {
            if (SOURCE_ID === exportConnectorId) {
              exportConnectorName = SOURCE_NAME;
            }
          }
        );

        return this.$message.EXPORT.NO_PERMISSION(exportConnectorName);
      };
    }
  },
  methods: {
    ...mapGetters(['connectorList']),
    updateSelectedOption(sourceId) {
      this.$emit('updateSelectedOption', sourceId);
    }
  }
};
</script>
<style scoped>
.export-options__item {
  padding: 8px 16px;
  border: 1px solid #e5e5e5;
  cursor: pointer;
  display: flex;
  align-items: center;
}
.export-options__item--selected {
  border: 1px solid #58e2c2;
  opacity: 1;
  font-weight: bold;
}
.export-options__item--disabled {
  opacity: 0.8;
  cursor: not-allowed;
}
.v-tooltip__content {
  color: #fff !important;
  background: #1b2342 !important;
  border-color: #1b2342 !important;
  padding: 4px 8px !important;
}
.tooltip {
  color: #fff !important;
  text-align: center;
  font-size: 10px;
  font-weight: normal;
  line-height: 16px;
  margin-bottom: 4px;
}

.v-skeleton-loader {
  margin: 0 !important;
}
</style>
